import React, {Component} from 'react';
import './sample.css';
import OwlCarousel from 'react-owl-carousel2';
import {TaskManagement, ExpenseReporting, LeadManagement} from './File';

class Sample extends Component{
  constructor(){
    super();
    this.state={
      class:'one',
      slides:<LeadManagement />
    }
    this.handleClick=this.handleClick.bind(this);
  }
  
  handleClick=(value)=>{
    if(value==="two"){
      this.setState({class:value,slides:<ExpenseReporting />})
    }else if(value==="three"){
      this.setState({class:value,slides:<TaskManagement />})
    }else{
      this.setState({class:value,slides:<LeadManagement />})
    }
  }
    render(){
      const options = {
        items: 1,
        nav: false,
        autoplay: true,
        loop:true,
        smartSpeed:700,
        animateOut: 'fadeOut',
        responsive: {
          '0': { items: 1 }
        }
    };
        return(
        <div id="sample">
          <h2 className="sample-title">
            Application 
          </h2>
          <div className="container">
            <div className="row">
              <div className="col-md">
                <div className="sample-element" >
                  <div className="row">
                    <div className="col-xs-12 col-md-3">
                        <div className="tab-header-holder">
                          <ul className={`list-unstyled sample-ul active-${this.state.class}`}>
                            <li onClick={()=>this.handleClick('one')}>
                              <span>Lead Management</span>
                            </li>
                            <li onClick={()=>this.handleClick('two')}>
                              <span>Expense Reporting</span>
                            </li>
                            <li onClick={()=>this.handleClick('three')}>
                              <span>Task Management​</span>
                            </li>
                          </ul>
                        </div>
                    </div>
                    <div className="col-xs-12 col-md-9">
                      <div className="owl-custom-holder">
                        <OwlCarousel ref="car" options={options}>
                          {this.state.slides}
                        </OwlCarousel>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    )
    }
}

export default Sample;


// WEBPACK FOOTER //
// ./src/components/Sample/Sample.js